import config from "config";
import { moneyFilter } from "../filters/money";
import API from "./http";

export const orderStatus = {
  PENDING: "Pendente",
  PROCESSING: "Processando",
  PAYMENT_REJECTED: "Rejeitado",
  PAYMENT_APPROVED: "Aprovado",
  CANCELED: "Cancelado",
  FINISHED: "Finalizado",
  ERROR: "Erro",
};

export const paymentTypes = {
  BANKSLIP: "Boleto",
  WIRETRANSFER: "Transferência",
  PORTABILITY: "Créditos de talões",
  PIX: "Pix",
};

const orders = {
  async all() {
    try {
      const res = await API.get(`${config.CORP_API_URL}/orders`);
      return res.data;
    } catch (err) {
      console.error("Error getting orders", err);
      throw err;
    }
  },
  async get(id) {
    try {
      const res = await API.get(`${config.CORP_API_URL}/order/${id}`);
      return res.data;
    } catch (err) {
      console.error("Error getting a order", err);
      throw err;
    }
  },
  async create(data, type) {
    try {
      const res = await API.post(`${config.CORP_API_URL}/order/${type}`, data);
      return res.data;
    } catch (err) {
      console.error("Error creating order", err);
      throw err;
    }
  },
  async cancel(id) {
    try {
      const res = await API.delete(`${config.CORP_API_URL}/order/${id}`);
      return res.data;
    } catch (err) {
      console.error("Error deleting order", err);
      throw err;
    }
  },
  async sendReceipt(id) {
    try {
      const res = await API.post(
        `${config.CORP_API_URL}/order/${id}/send-receipt`
      );
      return res.data;
    } catch (err) {
      console.error("Error sending receipt order", err);
      throw err;
    }
  },
  async resendInvoice(id) {
    try {
      const res = await API.post(
        `${config.CORP_API_URL}/order/${id}/resend-invoice`
      );
      return res.data;
    } catch (err) {
      console.error("Error resending invoice", err);
      throw err;
    }
  },
  async bankslipDownload(id) {
    // TODO: implementar
    throw new Error("Erro ao baixar o boleto", id);
  },
  async getProducts() {
    try {
      const res = await API.get(`${config.CORP_API_URL}/order/products`);
      const data = res.data;

      return data.products.reduce((products, { total }) => {
        products[total] = moneyFilter(total);
        return products;
      }, {});
    } catch (err) {
      console.error("Error getting a order", err);
      throw err;
    }
  },
};

export default orders;
